import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';

import { issuesPlugin } from '../plugin';
import { issueRouteRef } from '../routes';

export const IssueCollectionEntryExtension = issuesPlugin.provide(
  createCollectionEntryExtension({
    id: 'issue',
    resourceType: 'Issue',
    routeRef: issueRouteRef,
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource && resource.__typename === 'ObservationsV1Issue',
    render: () => null,
  }),
);
